import {
  GET_DATA_FAIL,
  GET_SHOPS,
  GET_SHOPS_SUCCESS,
  GET_SHOP_DETAILS,
  GET_SHOP_DETAILS_SUCCESS,
  GET_SHOP_DETAIL_FAIL,
  GET_SHOP_INITIAL_PRODUCTS_SUCCESS,
  GET_SHOP_OVERVIEW,
  GET_SHOP_OVERVIEW_FAIL,
  GET_SHOP_OVERVIEW_SUCCESS,
  GET_SHOP_PRODUCTS,
  GET_SHOP_PRODUCTS_FAIL,
  GET_SHOP_PRODUCTS_SUCCESS,
} from "../../actions/ecommerce/types";

const initialState = {
  data: [],
  params: null,
  allData: [],
  totalPages: 0,
  filteredData: [],
  totalRecords: 0,
  loading: false,
  overViewLoading: false,
  sortIndex: [],
  next: "",
  previous: "",
  shopOverview: {},
  shopDetails: {},
  productsLoading:false,
  products:[],
  productsCount:0,
};

const shop = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_SHOPS:
      return {
        ...state,
        loading: true,
      };
    case GET_SHOPS_SUCCESS:
      return {
        ...state,
        shops: payload,
        loading: false,
      };
    case GET_DATA_FAIL:
      return { ...state, loading: false, failed: true };

    case GET_SHOP_PRODUCTS:
      return {
        ...state,
        productsLoading: true,
      };
    // case GET_SHOP_INITIAL_PRODUCTS_SUCCESS:
    //   return {
    //     ...state,
    //     data: action.data,
    //     totalPages: action.totalPages,
    //     allData: action.data.results,
    //     loading: false,
    //   };
    case GET_SHOP_PRODUCTS_SUCCESS:
      return {
        ...state,
        products: payload.results,
        productsLoading: false,
        productsCount: payload.count,

      };
    // case GET_SHOP_PRODUCTS_FAIL:
    //   return { ...state, loading: false, failed: true };

    case GET_SHOP_DETAILS:
      return {
        loading: true,
      };
    case GET_SHOP_DETAILS_SUCCESS:
      return { ...state, shopDetails: payload, loading: false };
    case GET_SHOP_DETAIL_FAIL:
      return { ...state, loading: false, failed: true };

    case GET_SHOP_OVERVIEW:
      return {
        overViewLoading: true,
      };
    case GET_SHOP_OVERVIEW_SUCCESS:
      return { ...state, shopOverview: payload, overViewLoading: false };
    case GET_SHOP_OVERVIEW_FAIL:
      return { ...state, overViewLoading: false, failed: true };

    default: {
      return state;
    }
  }
};

export default shop;
